import React from "react";
import Reveal from "@/components/Reveal";
import {
  Hammer,
  Gem,
  Cpu,
  PenTool,
  Wrench,
  Clock,
  Coins,
  MessageSquare,
} from "lucide-react";

const REASONS = [
  { icon: Hammer, title: "Wieloletnie doświadczenie", desc: "Pokolenia praktyki w obróbce kamienia naturalnego." },
  { icon: Gem, title: "Najwyższa jakość materiałów", desc: "Granit, marmur i konglomeraty od sprawdzonych dostawców." },
  { icon: Cpu, title: "Nowoczesny park maszynowy CNC", desc: "Precyzja, którą czuć w każdym detalu." },
  { icon: PenTool, title: "Projekty indywidualne", desc: "Pracujemy pod konkretnego klienta, nie z katalogu." },
  { icon: Wrench, title: "Profesjonalny montaż", desc: "Pomiar, transport i montaż realizujemy własną ekipą." },
  { icon: Clock, title: "Terminowość", desc: "Realne terminy, których naprawdę dotrzymujemy." },
  { icon: Coins, title: "Konkurencyjne ceny", desc: "Stosunek jakości do ceny doceniany od lat." },
  { icon: MessageSquare, title: "Bezpłatna konsultacja", desc: "Wycena i doradztwo bez zobowiązań." },
];

export default function WhyUs() {
  return (
    <section id="dlaczego-my" data-testid="why-us-section" className="relative py-24 md:py-36 bg-[#050505] grain">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <Reveal className="lg:col-span-6">
            <p className="overline mb-6">Dlaczego my</p>
            <h2 className="section-title text-white text-4xl md:text-6xl leading-[1.04]">
              Osiem powodów,
              <br />
              <span className="italic text-neutral-300">aby zaufać kamieniarstwu Mrozek</span>.
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-neutral-900">
          {REASONS.map((r, i) => {
            const Icon = r.icon;
            return (
              <Reveal
                key={i}
                delay={i * 60}
                className="bg-[#050505] p-8 md:p-10 hover:bg-[#0a0a0a] transition-colors duration-500 group"
              >
                <div
                  data-testid={`why-us-item-${i}`}
                  className="flex flex-col h-full min-h-[200px]"
                >
                  <Icon size={28} strokeWidth={1} className="text-[var(--accent)] mb-6 group-hover:scale-110 transition-transform duration-500" />
                  <h3 className="font-serif-display text-white text-xl md:text-2xl mb-3 leading-snug">
                    {r.title}
                  </h3>
                  <p className="text-sm text-neutral-400 leading-relaxed">{r.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
